import { any } from 'ramda';

const NEW_POLICY_NO_MASK = /^[1-9][0-9]8[0-9]{5}[03-9][0-9]/;

/**
 * Checks, if policy No has valid CDV
 */
const isValidCDV = (policyNo) => {
	// new GCP validation
	const isValidNewGCPValidation = (policyNo) => {
		if (String(policyNo).match(NEW_POLICY_NO_MASK)) {
			const withoutCDV = Math.trunc(policyNo / 10);
			const withCDV = getPolicyNoWithCdvNew(withoutCDV);
			return withCDV === policyNo;
		}
		return false;
	};

	// old CP validation
	const isValidOldCPValidation = (policyNo) => {
		const withoutCDV = Math.trunc(policyNo / 100);
		const withCDV = getPolicyNoWithCdvOld(withoutCDV);
		return withCDV === policyNo;
	};

	// old GLI validation
	const isValidOldGLIValidation = (policyNo) => {
		const withoutCDV = Math.trunc(policyNo / 10);
		const withCDV = getPolicyNoWithCdvOldGli(withoutCDV);
		return withCDV === policyNo;
	};

	// all validations array for final checking
	const validationConditions = [
		isValidNewGCPValidation(policyNo),
		isValidOldCPValidation(policyNo),
		isValidOldGLIValidation(policyNo),
	];

	return any((condResult) => condResult === true)(validationConditions);
};

/**
 * Computes old CDV to policyNo
 */
const getPolicyNoWithCdvOld = (policyNo) => {
	let no = policyNo;
	let a = 0;
	let cdv = 0;
	a = a + 4 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 8 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 5 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 9 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 7 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 3 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 6 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 2 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 9;

	const c = Math.trunc(a % 11);

	if (c === 0) {
		cdv = 10;
	} else if (c === 1) {
		cdv = 28;
	} else {
		cdv = 10 + 11 - c;
	}

	return policyNo * 100 + cdv;
};

const gliTranslate = (n, idx) => {
	if (idx % 2 === 0) {
		return n;
	}
	if (n === '1') {
		return '2';
	} else if (n === '2') {
		return '4';
	} else if (n === '3') {
		return '6';
	} else if (n === '4') {
		return '8';
	} else if (n === '5') {
		return '1';
	} else if (n === '6') {
		return '3';
	} else if (n === '7') {
		return '5';
	} else if (n === '8') {
		return '7';
	}
	return n;
};

/**
 * Computes old GLI CDV to policyNo
 */
const getPolicyNoWithCdvOldGli = (policyNo) => {
	const policy = String(policyNo).padStart(9, '0');

	let sum = 0;
	const digits = policy.split('');
	for (let i = 0; i < digits.length; i++) {
		sum += parseInt(gliTranslate(digits[i], i + 1), 10);
	}

	const cdv = Math.trunc((100 - sum) % 10);

	return policyNo * 10 + cdv;
};

/**
 * Computes CDV to policyNo
 */
const getPolicyNoWithCdvNew = (policyNo) => {
	let no = policyNo;
	let a = 0;
	let cdv = 0;
	a = a + 7 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 3 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 1 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 7 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 3 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 1 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 7 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 3 * (no % 10);
	no = Math.trunc(no / 10);

	a = a + 1 * (no % 10);
	no = Math.trunc(no / 10);

	cdv = a % 10;

	return policyNo * 10 + cdv;
};

export default isValidCDV;
